export default "__VITE_ASSET__BMf4izVG__"